import axios from "axios";
import config from "../config";
import { getDoctorToken } from "../utils"

const saveScheduleTimingCustomize = async (params) => {
  const response = await axios({
    url: `${config.api.base_url}schedule-timing-customize`,
    method: params.mode,
    data: params,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getDoctorToken()}`
    },
  });

  return response;
};

export default saveScheduleTimingCustomize;
